import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "my-table"
};
const _hoisted_2 = {
  class: "my-table-item my-table-header"
};
const _hoisted_3 = {
  key: 0,
  class: "item"
};
const _hoisted_4 = {
  class: "version item"
};
const _hoisted_5 = {
  class: "time item"
};
const _hoisted_6 = {
  class: "description item"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "upload item"
}, null, -1);
const _hoisted_8 = {
  key: 0,
  class: "item"
};
const _hoisted_9 = {
  class: "version item"
};
const _hoisted_10 = {
  class: "time item"
};
const _hoisted_11 = {
  class: "description item"
};
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = {
  class: "description-content-right"
};
const _hoisted_14 = {
  class: "more-box"
};
const _hoisted_15 = {
  class: "upload item"
};
const _hoisted_16 = {
  key: 1,
  class: "no-history"
};
const _hoisted_17 = {
  class: "dialog-content-box"
};
const _hoisted_18 = ["innerHTML"];
const _hoisted_19 = {
  class: "btn-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_arrow_right = _resolveComponent("arrow-right");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_link = _resolveComponent("el-link");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.isProduct ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('message.product')), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('message.version')), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('message.releaseDate')), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('message.versionDescribe')), 1), _hoisted_7]), $setup.list.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($setup.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "my-table-item my-table-content",
      key: index,
      style: _normalizeStyle({
        height: item.nowHeight + 'px'
      })
    }, [$props.isProduct ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.productModel ? item.productModel.name || '' : ''), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, "V" + _toDisplayString(item.version), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(item.deployDate || item.lastUpdateTime || item.createTime || ''), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
      class: "description-content",
      ref_for: true,
      ref: "descriptionContentRef"
    }, [_createElementVNode("div", {
      class: _normalizeClass(["description-content-left", {
        ellipsis: item.ellipsis,
        tableCls: !item.ellipsis
      }])
    }, [_createElementVNode("p", {
      innerHTML: $setup.getHtml(item.description)
    }, null, 8, _hoisted_12)], 2), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [item.ellipsis ? (_openBlock(), _createBlock(_component_el_link, {
      key: 0,
      type: "primary",
      onClick: $event => $setup.ellipsisFn(index)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('message.more2')) + " ", 1), _createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_arrow_right)]),
        _: 1
      })]),
      _: 2
    }, 1032, ["onClick"])) : _createCommentVNode("", true)])])], 512)]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_link, {
      type: "primary",
      onClick: $event => $setup.clickDownLoad(item)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('message.download')), 1)]),
      _: 2
    }, 1032, ["onClick"])])], 4);
  }), 128)) : (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t('message.noData')), 1)), _createVNode(_component_el_dialog, {
    modelValue: $setup.dialogVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.dialogVisible = $event),
    width: "420px"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createElementVNode("p", {
      innerHTML: _ctx.$t('message.downloadOld')
    }, null, 8, _hoisted_18), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_button, {
      onClick: _cache[0] || (_cache[0] = $event => $setup.downloadContinue(false))
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('message.Download2_1_1')), 1)]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[1] || (_cache[1] = $event => $setup.downloadContinue(true))
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('message.Continue')), 1)]),
      _: 1
    })])])]),
    _: 1
  }, 8, ["modelValue"])]);
}